import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import veterinaryExamListAction from './veterinaryExamList.action.json' with { type: 'json' }
import { veterinaryExamObject } from '../veterinaryExamObject'

export const veterinaryExamExpression = expression(veterinaryExamObject.shape)

const veterinaryExamListDefinition = defineAction({
  ...veterinaryExamListAction,

  input: z.object({
    filter: veterinaryExamExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      type: 'Tipo',
      name: 'Nome',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(veterinaryExamObject),
    count: z.number(),
  }),
})

export default veterinaryExamListDefinition
